export default "__VITE_ASSET__Ay2zQhjW__"